<div
  id="sidebar-wrapper"
  class="relative h-screen flex flex-col border-r border-gray-200 bg-white transition-all duration-300 ease-in-out z-50"
  [ngClass]="isCollapsed ? 'w-24' : 'w-64'"
>
  <button
    *ngIf="!isHomeMode"
    (click)="toggleSidebar()"
    class="absolute -right-3 top-6 z-50 flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-500 shadow-sm hover:bg-gray-50 hover:text-primary transition-all duration-300 focus:outline-none opacity-100 scale-100"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
      <line x1="9" x2="9" y1="3" y2="21" />
    </svg>
  </button>

  <div
    class="sidebar-header w-full flex items-center h-20 overflow-hidden"
    [ngClass]="isCollapsed ? 'justify-center' : 'pl-[22px]'"
  >
    <a
      [routerLink]="isHomeMode ? null : '/home'"
      class="logo-box flex-shrink-0 relative overflow-hidden transition-all duration-300 rounded-lg"
      [ngClass]="isHomeMode ? 'cursor-default' : 'cursor-pointer group hover:bg-gray-100'"
    >
      <img
        [src]="moduleLogo"
        class="absolute inset-0 w-full h-full object-contain p-2.5 transition-all duration-300 opacity-100"
        [ngClass]="{ 'group-hover:opacity-0 group-hover:scale-75': !isHomeMode }"
        alt="Logo"
      />
      <span
        *ngIf="!isHomeMode"
        class="absolute inset-0 flex items-center justify-center transition-all duration-300 opacity-0 scale-75 group-hover:opacity-100 group-hover:scale-100"
      >
        <i class="pi pi-home text-xl text-white"></i>
      </span>
    </a>

    <div
      class="sidebar-brand whitespace-nowrap overflow-hidden transition-all duration-300 ease-in-out origin-left"
      [ngClass]="
        isCollapsed
          ? 'max-w-0 opacity-0'
          : 'max-w-xs opacity-100 ml-3 delay-100'
      "
    >
      {{ sidebarTitle }}
    </div>
  </div>

  <div
    class="sidebar-content custom-scrollbar w-full flex-1 min-h-0 overflow-y-auto overflow-x-hidden py-2"
  >
    <div *ngFor="let group of menuGroups" class="group-wrapper">
      <div
        class="overflow-hidden transition-all duration-500 ease-in-out"
        [ngClass]="{
          'opacity-100 mb-2': true,
        }"
      >
        <div
          *ngIf="group.name"
          class="group-header group-header-hover flex items-center min-h-[40px] transition-colors duration-200 select-none rounded-lg mx-2"
          [ngClass]="{
            'cursor-pointer': !group.isFixed,
            'cursor-default': group.isFixed,
            'text-gray-800': group.isExpanded && !group.isFixed,
            'text-gray-400': !group.isExpanded || group.isFixed,
            'justify-center': isCollapsed,
            'pl-[22px]': !isCollapsed,
          }"
          (click)="toggleGroup(group)"
          [pTooltip]="group.name"
          [tooltipDisabled]="!isCollapsed"
          tooltipPosition="right"
          tooltipStyleClass="custom-tooltip"
        >
          <span
            *ngIf="!isCollapsed"
            class="group-title overflow-hidden whitespace-nowrap transition-all duration-300 ease-in-out origin-left text-xs uppercase font-bold tracking-wider opacity-100 delay-100"
          >
            {{ group.name }}
          </span>

          <span
            *ngIf="isCollapsed && !group.isFixed"
            class="text-lg font-bold leading-none text-gray-400 hover:text-primary pb-2"
          >
            ...
          </span>

          <i
            *ngIf="!isCollapsed && !group.isFixed"
            class="pi pi-chevron-down arrow-icon ml-auto mr-6 text-xs transition-transform duration-300"
            [ngClass]="{ 'rotate-180': group.isExpanded }"
          ></i>
        </div>

        <div
          class="overflow-hidden transition-[max-height] duration-500 ease-in-out"
          [style.max-height]="
            group.isExpanded || group.isFixed ? '1200px' : '0px'
          "
        >
          <ul class="sidebar-nav m-0 p-0 list-none text-sm">
            <li
              *ngFor="let item of group.items"
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{ exact: item.exactMatch ?? item.exact ?? false }"
              class="mb-0"
            >
              <a
                [routerLink]="item.route"
                class="nav-link relative flex items-center h-11 text-gray-500 font-medium no-underline rounded-lg cursor-pointer transition-all duration-200 hover:bg-gray-100 hover:text-primary mx-2"
                [ngClass]="isCollapsed ? 'justify-center' : 'pl-[22px]'"
                [pTooltip]="item.name"
                [tooltipDisabled]="!isCollapsed"
                tooltipPosition="right"
                tooltipStyleClass="custom-tooltip"
              >
                <i
                  [class]="item.icon"
                  class="nav-icon text-lg flex-shrink-0 transition-colors duration-200 w-6 text-center"
                ></i>

                <span
                  class="whitespace-nowrap overflow-hidden transition-all duration-300 ease-in-out origin-left"
                  [ngClass]="
                    isCollapsed
                      ? 'max-w-0 opacity-0'
                      : 'max-w-[200px] opacity-100 ml-3 delay-100'
                  "
                >
                  {{ item.name }}
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- See All button -->
    <div *ngIf="currentModule" class="mx-2 mt-1 mb-2">
      <button
        type="button"
        class="w-full flex items-center rounded-lg h-11 text-gray-400 hover:bg-gray-100 hover:text-[var(--primary-500)] transition-all duration-200 group"
        [ngClass]="isCollapsed ? 'justify-center' : 'pl-[22px]'"
        [pTooltip]="isCollapsed ? 'See All Entities' : ''"
        tooltipPosition="right"
        tooltipStyleClass="custom-tooltip"
        (click)="openEntityPanel()"
      >
        <i class="pi pi-th-large text-lg flex-shrink-0 w-6 text-center transition-colors duration-200"></i>
        <span
          class="whitespace-nowrap overflow-hidden transition-all duration-300 ease-in-out origin-left text-sm font-medium"
          [ngClass]="isCollapsed ? 'max-w-0 opacity-0' : 'max-w-[200px] opacity-100 ml-3 delay-100'"
        >
          See All
        </span>
      </button>
    </div>
  </div>

  <div
    *ngIf="isUserMenuOpen"
    class="fixed inset-0 z-40 cursor-default"
    (click)="isUserMenuOpen = false"
  ></div>

  <div class="user-section w-full relative z-50">
    <div
      *ngIf="isUserMenuOpen"
      class="absolute bg-white border border-gray-100 shadow-xl rounded-lg overflow-hidden transition-all duration-200 animate-fade-in"
      [ngClass]="isCollapsed ? 'popup-collapsed' : 'popup-expanded'"
    >
      <div class="p-0">
        <button
          (click)="openEditProfile()"
          class="w-full flex items-center px-5 py-4 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors text-left group"
        >
          <i
            class="pi pi-user-edit mr-3 text-gray-400 group-hover:text-blue-500"
          ></i>
          <span class="font-medium">Edit Profile</span>
        </button>
      </div>

      <div class="p-0">
        <button
          (click)="logout()"
          class="w-full flex items-center px-5 py-4 text-sm text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors text-left group"
        >
          <i
            class="pi pi-sign-out mr-3 text-gray-400 group-hover:text-red-500"
          ></i>
          <span class="font-medium">Sign Out</span>
        </button>
      </div>
    </div>

    <div
      class="user-card flex items-center h-16 cursor-pointer transition-all duration-200 hover:bg-gray-50 border-t border-gray-100"
      [ngClass]="isCollapsed ? 'justify-center' : 'pl-[18px]'"
      (click)="toggleUserMenu()"
    >
      <div
        class="user-avatar flex-shrink-0 ring-2 ring-transparent hover:ring-gray-200 transition-all"
      >
        <i class="pi pi-user text-gray-600"></i>
      </div>

      <div
        class="user-info overflow-hidden whitespace-nowrap transition-all duration-300 ease-in-out origin-left"
        [ngClass]="
          isCollapsed
            ? 'max-w-0 opacity-0'
            : 'max-w-[180px] opacity-100 ml-3 delay-100'
        "
      >
        <p class="user-name">
          {{ displayName }}
        </p>
        <p class="user-email">
          {{ currentUser?.user?.email || currentUser?.email || "loading..." }}
        </p>
      </div>
    </div>
  </div>
</div>
